<script setup lang="ts">
const props = defineProps({
    columns: {
        required: true,
        type: Array as () => string[],
    },
});

const gridCols = `grid-cols-${props.columns?.length}`;
</script>

<template>
    <div role="treegrid" :class="`grid ${gridCols}`">
        <div
            class="sticky top-[60px] z-10 col-span-full grid grid-cols-subgrid bg-white p-4"
        >
            <div role="row" class="col-span-full grid grid-cols-subgrid gap-7">
                <BaseText
                    v-for="(column, index) in columns"
                    :key="index"
                    role="columnheader"
                    variant="base-500"
                    class="hyphens-auto"
                >
                    {{ column }}
                </BaseText>
            </div>
        </div>
        <div
            class="z-0 col-span-full grid grid-cols-subgrid divide-y p-4 text-left"
        >
            <slot name="body" />
        </div>
    </div>
</template>
